export enum NotificationState {
  None = 0,
  Queued = 1,
  Processing = 2,
  Complete = 3,
  Failed = 4
}
